export default "__VITE_ASSET__ZQFCIiuC__"